import request from '@/utils/request'

// 查询企业信息列表
export function listEnterpriseinfo(query) {
  return request({
    url: '/screen/creditlibrary/enterpriseinfo/selectEnterprise',
    method: 'get',
    params: query
  })
}

// 查询企业信息详细
export function getEnterpriseinfo(pid) {
  return request({
    url: '/screen/creditlibrary/enterpriseinfo/detail/' + pid,
    method: 'get'
  })
}

// 新增企业信息
export function addEnterpriseinfo(data) {
  return request({
    url: '/screen/creditlibrary/enterpriseinfo/add',
    method: 'post',
    data: data
  })
}

// 修改企业信息
export function updateEnterpriseinfo(data) {
  return request({
    // url: '/screen/creditlibrary/enterpriseinfo/edit',
    // url: '/screen/enterpriseinfo/edit',
    url: '/screen/creditlibrary/enterpriseinfo/saveEnterprise',
    method: 'post',
    data: data
  })
}

// 删除企业信息
export function delEnterpriseinfo(pid) {
  return request({
    url: '/screen/creditlibrary/enterpriseinfo/delete/' + pid,
    method: 'get'
  })
}
